import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#auto-loan-app', App);
